import * as actions from "./actionsTypes";

const initialData = {
  loaderCriteriosEvaluador: false,
  criteriosEvaluador: null,
  criteriosEvaluadorFalla: null,
  saveLoaderCriteriosEvaluador: false,
  criteriosEvaluadorFormError:null,
  criteriosEvaluadorLenght: 0
};

export default function CriteriosEvaluadorReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_CRITERIOS_EVALUADOR:
      return { ...state, loaderCriteriosEvaluador: action.payload };

    case actions.GET_CRITERIOS_EVALUADOR:
      return { ...state, criteriosEvaluador: action.payload };

    case actions.CRITERIOS_EVALUADOR_FALLA:
      return { ...state, criteriosEvaluadorFalla: action.payload };

    case actions.SAVE_LOADER_CRITERIOS_EVALUADOR:
      return { ...state, saveLoaderCriteriosEvaluador: action.payload };

    case actions.FORM_CRITERIOS_EVALUADOR_FAIL:
      return { ...state, criteriosEvaluadorFormError: action.payload };

    default:
      return state;
  }
}
